var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col posting_Card_container w-full sm:w-[355px] p-3 pb-1 bg-white transition delay-75 duration-200 ease-in-out",
    },
    [
      _c("PostCard", {
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("PostingCardHeader", {
                  staticClass: "mb-2",
                  attrs: {
                    posting: _vm.posting,
                    applications: _vm.applicants,
                    canEdit: _vm.canEdit,
                  },
                  on: {
                    "post:edit": function ($event) {
                      _vm.dialog = true
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("PostingCardBody", {
                  attrs: {
                    posting: _vm.posting,
                    applications: _vm.applicants,
                    canEdit: _vm.canEdit,
                    inactiveManager: _vm.inactiveManager,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col" },
                  [
                    _c("ItemsRenderer", {
                      staticClass: "border-t-1 py-4",
                      attrs: {
                        items: _vm.skills,
                        title: "Skills",
                        content_class: "ml-6",
                      },
                    }),
                    _c("ItemsRenderer", {
                      staticClass: "border-t-1 py-4",
                      attrs: {
                        items: _vm.industries,
                        title: "Industries",
                        content_class: "ml-1",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.dialog
        ? _c("PostingModal", {
            attrs: {
              companyId: _vm.companyId,
              data: _vm.posting,
              managerId: _vm.managerId,
            },
            model: {
              value: _vm.dialog,
              callback: function ($$v) {
                _vm.dialog = $$v
              },
              expression: "dialog",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }